import { render, staticRenderFns } from "./staking.vue?vue&type=template&id=b452e5ea&scoped=true&lang=pug&"
import script from "./staking.vue?vue&type=script&lang=js&"
export * from "./staking.vue?vue&type=script&lang=js&"
import style0 from "./staking.vue?vue&type=style&index=0&id=b452e5ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b452e5ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b452e5ea')) {
      api.createRecord('b452e5ea', component.options)
    } else {
      api.reload('b452e5ea', component.options)
    }
    module.hot.accept("./staking.vue?vue&type=template&id=b452e5ea&scoped=true&lang=pug&", function () {
      api.rerender('b452e5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/openapi/dialog/staking.vue"
export default component.exports